import React, { useEffect, useState } from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import {  useParams, Link } from "react-router-dom";
import axios from "axios";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";

const Deliverynoteinward_new = () => {
    useAuthRedirect();
    const { delNo } = useParams();

    const [headerDetails, setHeaderDetails] = useState({});
    const [itemDetails, setItemDetails] = useState([]);

    const [loading, setLoading] = useState(true); // ✅ loading state

  useEffect(() => {
    const fetchDetails = async () => {
      if (!delNo) {
        console.log("No Delivery Note Number (delNo) provided");
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/deliveryNote_detail?delNo=${delNo}`
        );

        if (response.data && response.data.deliveryDetail?.length > 0) {
          const items = response.data.deliveryDetail;

          const header = {
            del_no: items[0].del_no,
            del_id: items[0].del_id,
            frombranch: items[0].frombranch,
            tobranch: items[0].tobranch,
            del_send: items[0].del_send,
            del_date: items[0].del_date,
          };

          setHeaderDetails(header);
          setItemDetails(items);
        } else {
          console.warn("API Response does not contain expected data structure");
          setItemDetails([]);
        }
      } catch (error) {
        console.error("Error fetching delivery details:", error);
      } finally {
        setLoading(false); // ✅ stop loading in all cases
      }
    };

    fetchDetails();
  }, [delNo]);
 
    return (
        <div id="admin-container">
            <InventoryNav />
            <div className="content-right">
                <section>
                        <div className="back-div">
                                                                                <h2 className="add-txt">Delivery Note Details</h2>
                                                                                <Link to='/inventory/deliveryNoteInwardReport'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                                                                </div>
                    
                    <Time />
                </section>

                <div className="form-container">
                    <form className="vehicle-form">
                        <div className="form-row">
                            <div className="form-group">
                                <label>Del No :</label>
                                <input type="text" value={delNo} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Date :</label>
                                <input type="text" value={headerDetails.del_date ? new Date(headerDetails.del_date).toLocaleDateString('en-GB') : "N/A"} readOnly />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>From Branch :</label>
                                <input type="text" value={headerDetails?.frombranch} readOnly />
                            </div>
                            <div className="form-group">
                                <label>To Branch :</label>
                                <input type="text" value={headerDetails?.tobranch} readOnly />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Send Through :</label>
                                <input type="text" value={headerDetails?.del_send} readOnly />
                            </div>
                            <div className="form-group">
                                <label></label>
                                <input type="hidden" />
                            </div>
                        </div>

                        <table className="items-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Descriptions</th>
                                    <th>Specification/Part No</th>
                                    <th>UOM</th>
                                    <th>Del.Qty</th>
                                    <th>Rec.Qty</th>
                                    <th>Bal.Qty</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                               <tbody>
      {loading ? (
        <tr>
          <td colSpan="8" style={{ textAlign: "center" }}>
            Loading...
          </td>
        </tr>
      ) : itemDetails.length > 0 ? (
        itemDetails.map((item, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{item.del_description}</td>
            <td>{item.del_specification}</td>
            <td>{item.del_UM}</td>
            <td>{item.Del_Qty || 0}</td>
            <td>{item.Rec_Qty || 0}</td>
            <td>{item.Bal_Qty || 0}</td>
            <td>{item.del_remarks}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="8" style={{ textAlign: "center" }}>
            No items found
          </td>
        </tr>
      )}
    </tbody>



                        </table>
                      
                        
                    </form>
                    <div className="btn-cls">
                        <Link to={`/inventory/deliveryinwardnote_print/${delNo}`} target="_blank">
                    <button className="add-new-btn">Print</button>
                  </Link>
                        </div>
                </div>
            </div>
        </div>
    );
};

export default Deliverynoteinward_new;
